import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27a53548"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "date_list" };
const _hoisted_2 = { class: "crypto-stake-is" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "diamond" }, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "diamond" }, null, -1));
const _hoisted_5 = {
    key: 0,
    class: "crypto-stake-is"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "diamond" }, null, -1));
const _hoisted_7 = {
    key: 1,
    class: "crypto-stake-is"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "diamond" }, null, -1));
import { useMessage } from '@/const/messages';
import { useStakingInterestSchedule } from '@/logics/staking_interest_schedule';
import { setTimezone } from '@/logics/utils';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        date: null,
        term: null
    },
    setup(__props) {
        const props = __props;
        const { getStartDate, getDateNow, getMaturityDate, getRedemptionDate } = useStakingInterestSchedule();
        const { STAKECONFIRM, format } = useMessage();
        const store = useStore();
        const FREE_PLAN = 1;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).APPDATE)), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), _unref(getDateNow)(props.date), 'YYYY-MM-DD HH:mm:ss')), 1)
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["crypto-stake-is", { 'remove-bar': props.term === FREE_PLAN }])
                }, [
                    _hoisted_4,
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).STARTDATE)), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), _unref(getStartDate)(props.date), 'YYYY-MM-DD')), 1)
                ], 2),
                (props.term !== FREE_PLAN)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).ENDDATE)), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), _unref(getMaturityDate)(props.date, props.term), 'YYYY-MM-DD')), 1)
                    ]))
                    : _createCommentVNode("", true),
                (props.term !== FREE_PLAN)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKECONFIRM).REDEMDATE)), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), _unref(getRedemptionDate)(props.date, props.term), 'YYYY-MM-DD HH:mm:ss')), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
